export default {"src":"/_next/static/media/product-placeholder.e9509f23.svg","height":71,"width":71,"blurWidth":0,"blurHeight":0};